import { Component, Input, OnInit } from '@angular/core';
import { Sector } from '../models/Sector';
import { SectorService } from '../services/sector.service';

@Component({
  selector: 'app-sectoresbanner',
  templateUrl: './sectoresbanner.component.html',
  styleUrls: ['./sectoresbanner.component.css']
})
export class SectoresbannerComponent implements OnInit {

 @Input()
 titleSectores: string = "inicial";


  sectores: Sector[];
  //titulo: string;

  constructor(
    //injectando servicio SECTORES
    private sectorService: SectorService
  ) { }

  ngOnInit(): void {
    this.sectorService.getSectores().subscribe( res => {
      this.sectores = res;
      //
      console.log(res);
      
    });
    console.log(this.titleSectores)
  }

}